const isPromise = p => typeof p === 'object' && typeof p.then === 'function'

export default isPromise
